import * as Yup from 'yup';
import { REQUIRED_FIELD } from 'src/constants';

const phoneNumberValidation = Yup.string()
  .nullable()
  .transform((value, originalValue) => {
    if (originalValue === '' || originalValue == null) return null;

    const stringValue = String(originalValue);

    if (stringValue === '0') return null;

    return stringValue;
  })
  .test('is-valid-phone', 'Phone number must be 10 digits', function (value) {
    if (!value) return true;

    return /^\d{10}$/.test(value);
  });

const orgProfileValidation = Yup.object().shape({
  organizationData: Yup.object().shape({
    organization: Yup.object().shape({
      id: Yup.number().nullable(),
      name: Yup.string().nullable().required(REQUIRED_FIELD),
      locationCode: Yup.string()
        .trim()
        .max(3, 'Location code must be at most 3 characters')
        .nullable(),

      facilityIdentificationNumber: Yup.string()
        .trim()
        .max(5, 'FIN must be at most 5 characters')
        .nullable(),
      organizationTypeId: Yup.number().nullable().required(REQUIRED_FIELD),
      createdBy: Yup.number().nullable(),
      crmOrganizationHours: Yup.mixed().nullable(),
      crmOrganizationTransportationInfo: Yup.mixed().nullable(),
      active: Yup.boolean().default(true),
      createdDate: Yup.string().nullable(),
      updatedDate: Yup.string().nullable(),
      deletedDate: Yup.string().nullable(),
      contactMethods: Yup.object()
        .shape({
          emails: Yup.array()
            .of(
              Yup.object().shape({
                id: Yup.number().nullable(),
                active: Yup.boolean().default(true),
                contactMechanismId: Yup.number().nullable(),
                email: Yup.string()
                  .nullable()
                  .transform((value) => (value === '' ? null : value))
                  .email('Invalid email address'),
                emailTypeId: Yup.number().nullable(),
                contactMechanismTypeId: Yup.number().nullable(),
              }),
            )
            .default([]),
          addresses: Yup.array()
            .of(
              Yup.object().shape({
                id: Yup.number().nullable(),
                active: Yup.boolean().default(true),
                contactMechanismId: Yup.number().nullable(),
                line1: Yup.string().nullable(),
                line2: Yup.string().nullable(),
                line3: Yup.string().nullable(),
                city: Yup.string().nullable(),
                stateProvinceCode: Yup.string().nullable(),
                postalCode: Yup.string().nullable(),
                countryCode: Yup.number().default(1),
                postalAddressTypeId: Yup.number().nullable(),
                contactMechanismTypeId: Yup.number().nullable(),
              }),
            )
            .default([]),
          phones: Yup.array()
            .of(
              Yup.object().shape({
                id: Yup.number().nullable(),
                active: Yup.boolean().default(true),
                contactMechanismId: Yup.number().nullable(),
                phoneNumber: phoneNumberValidation,
                countryCode: Yup.number().default(1),
                extension: Yup.string().nullable(),
                phoneNumberTypeId: Yup.number().nullable(),
                contactMechanismTypeId: Yup.number().nullable(),
              }),
            )
            .default([]),
          faxes: Yup.array()
            .of(
              Yup.object().shape({
                id: Yup.number().nullable(),
                active: Yup.boolean().default(true),
                contactMechanismId: Yup.number().nullable(),
                faxNumber: phoneNumberValidation,
                countryCode: Yup.number().default(1),
                contactMechanismTypeId: Yup.number().nullable(),
              }),
            )
            .default([]),
        })
        .default({}),
      contacts: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.number().nullable(),
            firstName: Yup.string().nullable(),
            lastName: Yup.string().nullable(),
            departmentId: Yup.number().nullable(),
            title: Yup.string().nullable(),
            active: Yup.boolean().default(true),
            contactMethods: Yup.object()
              .shape({
                emails: Yup.array()
                  .of(
                    Yup.object().shape({
                      id: Yup.number().nullable(),
                      active: Yup.boolean().default(true),
                      contactMechanismId: Yup.number().nullable(),
                      email: Yup.string().nullable(),
                      emailTypeId: Yup.number().nullable(),
                      contactMechanismTypeId: Yup.number().nullable(),
                    }),
                  )
                  .default([]),
                phones: Yup.array()
                  .of(
                    Yup.object().shape({
                      id: Yup.number().nullable(),
                      active: Yup.boolean().default(true),
                      contactMechanismId: Yup.number().nullable(),
                      phoneNumber: Yup.number().nullable(),
                      countryCode: Yup.number().default(1),
                      extension: Yup.string().nullable(),
                      phoneNumberTypeId: Yup.number().nullable(),
                      contactMechanismTypeId: Yup.number().nullable(),
                    }),
                  )
                  .default([]),
                faxes: Yup.array()
                  .of(
                    Yup.object().shape({
                      id: Yup.number().nullable(),
                      active: Yup.boolean().default(true),
                      contactMechanismId: Yup.number().nullable(),
                      faxNumber: Yup.number().nullable(),
                      countryCode: Yup.number().default(1),
                      contactMechanismTypeId: Yup.number().nullable(),
                    }),
                  )
                  .default([]),
                addresses: Yup.array().default([]),
              })
              .default({}),
          }),
        )
        .default([]),
      notes: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.number().nullable(),
            noteText: Yup.string().nullable(),
            noteTypeId: Yup.number().nullable(),
          }),
        )
        .default([]),
      units: Yup.array()
        .of(
          Yup.object().shape({
            active: Yup.boolean().default(true),
            id: Yup.number().nullable(),
            name: Yup.string().nullable(),
            description: Yup.string().nullable(),
            contactMethods: Yup.object()
              .shape({
                emails: Yup.array().default([]),
                addresses: Yup.array().default([]),
                phones: Yup.array()
                  .of(
                    Yup.object().shape({
                      id: Yup.number().nullable(),
                      active: Yup.boolean().default(true),
                      contactMechanismId: Yup.number().nullable(),
                      phoneNumber: Yup.number().nullable(),
                      countryCode: Yup.number().default(1),
                      extension: Yup.string().nullable(),
                      phoneNumberTypeId: Yup.number().nullable(),
                      contactMechanismTypeId: Yup.number().nullable(),
                    }),
                  )
                  .default([]),
                faxes: Yup.array().default([]),
              })
              .default({}),
          }),
        )
        .default([]),
      relationships: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.number().nullable(),
            active: Yup.boolean().default(true),
            fromParty: Yup.object()
              .shape({
                id: Yup.number().nullable(),
                name: Yup.string().nullable(),
              })
              .nullable(),
            primaryContact: Yup.object()
              .shape({
                id: Yup.number().nullable(),
                firstName: Yup.string().nullable(),
                lastName: Yup.string().nullable(),
                title: Yup.string().nullable(),
                contactMethods: Yup.object().default({}),
              })
              .nullable(),
            fromRole: Yup.object()
              .shape({
                id: Yup.number().nullable(),
                name: Yup.string().nullable(),
              })
              .nullable(),
            priority: Yup.object()
              .shape({
                id: Yup.number().nullable(),
                name: Yup.string().nullable(),
              })
              .nullable(),
          }),
        )
        .default([]),
      corneagenRoleTypeIds: Yup.array()
        .of(Yup.number().required())
        .min(1, REQUIRED_FIELD)
        .required(REQUIRED_FIELD),
    }),
    newOrganizationId: Yup.number().nullable(),
  }),
  user: Yup.string().default(''),
  submitted: Yup.boolean().default(false),
});

export default orgProfileValidation;
